import { Directive } from '@angular/core';
import { CheckUnsavedForms } from '../interfaces/check-unsaved-forms';

@Directive({
    selector: '[appCheckUnsavedForms]',
    standalone: true
})
export class CheckUnsavedFormsDirective {
  //TODO:  What do we need to do here?
  /**
   * Need to add the directive provider to the component you use this directive in https://stackoverflow.com/a/54143054
   */
  constructor(public readonly ref: CheckUnsavedForms) {}
}
